export default `<html>

<head>
<meta http-equiv=Content-Type content='text/html; charset=utf-8'>
<meta name=Generator content='Microsoft Word 15 (filtered)'>
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:宋体;
	panose-1:2 1 6 0 3 1 1 1 1 1;}
@font-face
	{font-family:'Cambria Math';
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
@font-face
	{font-family:微软雅黑;
	panose-1:2 11 5 3 2 2 4 2 2 4;}
@font-face
	{font-family:'\@微软雅黑';}
@font-face
	{font-family:'\@宋体';
	panose-1:2 1 6 0 3 1 1 1 1 1;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0cm;
	text-align:justify;
	text-justify:inter-ideograph;
	font-size:10.5pt;
	font-family:'Calibri',sans-serif;}
p
	{margin-right:0cm;
	margin-left:0cm;
	font-size:12.0pt;
	font-family:'Calibri',sans-serif;}
 /* Page Definitions */
 @page WordSection1
	{size:595.3pt 841.9pt;
	margin:72.0pt 90.0pt 72.0pt 90.0pt;
	layout-grid:15.6pt;}
div.WordSection1
	{page:WordSection1;}
-->
</style>

</head>

<body lang=ZH-CN style='word-wrap:break-word;text-justify-trim:punctuation'>

<div class=WordSection1 style='layout-grid:15.6pt'>

<p style='text-indent:32.0pt'><span style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>根据《中国银保监会关于银行保险机构员工履职回避工作的指导意见》（银保监发<span
lang=EN-US>[2019]50</span>号）等有关制度规定，现将任职人员情况公示如下：</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width=649
 style='width:486.8pt;border-collapse:collapse;border:none'>
 <tr style='height:42.75pt'>
  <td width=42 style='width:31.6pt;border:solid windowtext 1.0pt;background:
  #AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体'>序号</span></b></p>
  </td>
  <td width=61 style='width:45.9pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>姓名</span></b></p>
  </td>
  <td width=47 style='width:35.6pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>性别</span></b></p>
  </td>
  <td width=63 style='width:47.4pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>成长地</span></b></p>
  </td>
  <td width=158 style='width:118.5pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>现任职务</span></b></p>
  </td>
  <td width=142 style='width:106.65pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>拟任职务</span></b></p>
  </td>
  <td width=135 style='width:101.15pt;border:solid windowtext 1.0pt;border-left:
  none;background:#AEAAAA;padding:0cm 5.4pt 0cm 5.4pt;height:42.75pt'>
  <p class=MsoNormal align=center style='text-align:center'><b><span
  style='font-size:12.0pt;font-family:宋体;color:black'>备注</span></b></p>
  </td>
 </tr>
 <tr style='height:33.25pt'>
  <td width=42 style='width:31.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=EN-US>1</span></p>
  </td>
  <td width=61 style='width:45.9pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>刘海峰</span></p>
  </td>
  <td width=47 style='width:35.6pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>男</span></p>
  </td>
  <td width=63 style='width:47.4pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>海南</span></p>
  </td>
  <td width=158 style='width:118.5pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>海南分公司临时负责人</span></p>
  </td>
  <td width=142 style='width:106.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:33.25pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>海南分公司总经理</span></p>
  </td>
  <td width=135 rowspan=4 valign=top style='width:101.15pt;border-top:none;
  border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:33.25pt'>
  <p class=MsoNormal><span style='font-family:宋体'>结合工作需要及公司领导意见，根据《中国银保监会关于银行保险机构员工履职回避工作的指导意见》相关规定，现履行履职回避豁免公示。</span></p>
  </td>
 </tr>
 <tr style='height:30.55pt'>
  <td width=42 style='width:31.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=EN-US>2</span></p>
  </td>
  <td width=61 style='width:45.9pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>卢洋</span></p>
  </td>
  <td width=47 style='width:35.6pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>男</span></p>
  </td>
  <td width=63 style='width:47.4pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>江西</span></p>
  </td>
  <td width=158 style='width:118.5pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>江西分公司临时负责人</span></p>
  </td>
  <td width=142 style='width:106.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:30.55pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>江西分公司总经理</span></p>
  </td>
 </tr>
 <tr style='height:29.85pt'>
  <td width=42 style='width:31.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=EN-US>3</span></p>
  </td>
  <td width=61 style='width:45.9pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>井晓强</span></p>
  </td>
  <td width=47 style='width:35.6pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>男</span></p>
  </td>
  <td width=63 style='width:47.4pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>陕西</span></p>
  </td>
  <td width=158 style='width:118.5pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>陕西分公司临时负责人</span></p>
  </td>
  <td width=142 style='width:106.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:29.85pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>陕西分公司总经理</span></p>
  </td>
 </tr>
 <tr style='height:28.1pt'>
  <td width=42 style='width:31.6pt;border:solid windowtext 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=EN-US>4</span></p>
  </td>
  <td width=61 style='width:45.9pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=ZH
  style='font-family:宋体'>郝永庆</span></p>
  </td>
  <td width=47 style='width:35.6pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span
  style='font-family:宋体'>男</span></p>
  </td>
  <td width=63 style='width:47.4pt;border-top:none;border-left:none;border-bottom:
  solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=ZH
  style='font-family:宋体'>青岛</span></p>
  </td>
  <td width=158 style='width:118.5pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=ZH
  style='font-family:宋体'>青岛分公司临时负责人</span></p>
  </td>
  <td width=142 style='width:106.65pt;border-top:none;border-left:none;
  border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:28.1pt'>
  <p class=MsoNormal align=center style='text-align:center'><span lang=ZH
  style='font-family:宋体'>青岛</span><span style='font-family:宋体'>分公司总经理</span></p>
  </td>
 </tr>
</table>

<p><span style='font-size:16.0pt;font-family:'微软雅黑',sans-serif;color:white'>公示时间：</span><span
lang=EN-US style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>2020</span><span
style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>年<span lang=EN-US>11</span>月<span
lang=EN-US>9</span>日至<span lang=EN-US>2020</span>年<span lang=EN-US>11</span>月<span
lang=EN-US>13</span>日。</span></p>

<p><span style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>公示期间，任何机构或个人均可通过邮件、来信、来访等方式向福保经纪反映公示对象在履职回避方面存在的有关问题。</span></p>

<p><span style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>电子邮箱：<span
lang=EN-US>zhengyang@fubaobaoxian.com</span></span></p>

<p><span style='font-size:16.0pt;font-family:'微软雅黑',sans-serif'>反映情况应实事求是，客观公正。为便于核实反馈的情况，提倡反映人提供真实信息及联系方式，福保经纪将严格遵守工作纪律，履行保密义务。</span></p>

<p style='margin-top:2.5pt;margin-right:0cm;margin-bottom:2.5pt;margin-left:
0cm;text-indent:22.2pt'><span lang=EN-US style='font-size:16.0pt;font-family:
'微软雅黑',sans-serif;color:#333333'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US>&nbsp;</span></p>

</div>

</body>

</html>
`


// WEBPACK FOOTER //
// ./src/assets/file/file.js